import * as React from 'react';
import styled, { css } from 'styled-components';
import { Text } from '@amzn/storm-ui';
import { AccountLabel } from './AccountLabel';
import { Account } from '@amzn/aac-chrome-internal-api';

const contentsContainerMixin = css`
  &&& {
    color: ${({ theme }) => theme.color.gray[700]};
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme }) =>
      `${theme.spacing.xxxsmall.default} ${theme.spacing.base.default}`};
    outline: revert;
    text-align: start;
    min-height: 40px;
  }
`;

export const AdvertisingAccountLink = styled.a`
  ${contentsContainerMixin};
`;

export const AdvertisingAccountContainer = styled.div`
  ${contentsContainerMixin};
`;

export const AdvertisingAccountMarketplaceName = styled(Text)`
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const RetailerName = styled(Text)`
  color: ${({ theme }) => theme.color.gray[700]};
`;

type AdvertisingAccountContentType = {
  label: string;
  countryLabel: string;
  retailerName?: string;
};

const AdvertisingAccountContent: React.FC<AdvertisingAccountContentType> = ({
  label,
  countryLabel,
  retailerName,
}) => {
  return (
    <span>
      <AccountLabel label={label} />
      {retailerName && (
        <RetailerName size="xsmall">{retailerName}</RetailerName>
      )}
      {countryLabel && (
        <AdvertisingAccountMarketplaceName size="xsmall">
          {countryLabel}
        </AdvertisingAccountMarketplaceName>
      )}
    </span>
  );
};

export const IA2AdvertisingAccountItem: React.FC<{
  advertisingAccount: Account;
  countryLabel: string;
  isSelected: boolean;
  retailerName?: string;
}> = ({ advertisingAccount, countryLabel, isSelected, retailerName }) => {
  const contents = (
    <AdvertisingAccountContent
      label={advertisingAccount.label}
      countryLabel={countryLabel}
      retailerName={retailerName}
    />
  );
  if (isSelected) {
    return (
      <AdvertisingAccountContainer>{contents}</AdvertisingAccountContainer>
    );
  }

  return (
    <AdvertisingAccountLink
      data-ccx-e2e-id="aac-account-link"
      href={advertisingAccount.url}
      draggable="false"
    >
      {contents}
    </AdvertisingAccountLink>
  );
};
